import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {DevicesRequestsService} from "../../../devices/services/devices-requests.service";

export class DeliveryHistoryTableCtrl implements IController {
  delivery: any;
  history: any;
  selectedAction: any;
  onSelectAction: Function;

  private devicesMap: any;
  private actionLocationMap: any;

  /* @ngInject */
  constructor(private devicesRequestsService: DevicesRequestsService, private $log, private latLngToAddress) {
  }

  $onInit() {
    this.devicesMap = {};
    this.actionLocationMap = {};

    _.forEach(_.filter(this.history, (h) => {
      return !h.courierAction.manual
    }), (history) => {
      this._getDevicesData(_.get(history, 'courierAction.agentId'));
      this._setLocationAddress(_.get(history, 'ts'), _.get(history, 'courierAction.location'));
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  // onSelectActionRow(action) {
  //   this.selectedAction = !_.get(action, 'courierAction.manual') && !_.isEqual(_.get(this.selectedAction, 'ts'), action.ts) ? action : undefined;
  //   this.onSelectAction({action: this.selectedAction});
  // }

  private _getDevicesData(agentId) {
    this.devicesRequestsService.getDevices(agentId)
      .then((devices) => {
        this.devicesMap[agentId] = devices.length ? devices[0] : undefined;
      })
      .catch((error) => {
        this.$log.error('Failed to get devices by agent @deliveryHistoryTable@$onInit', error);
      });
  }

  private _setLocationAddress(historyTs, location) {
    this.latLngToAddress(location.latitude, location.longitude)
      .then((place) => {
        this.actionLocationMap[historyTs] = {
          lat: location.lat,
          lng: location.lng,
          place: place
        };
      })
      .catch((error) => {
        this.$log.error('Failed to get address by coordinates,' +
          'agentLocation@ctrl.$onInit', error)
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryHistoryTable', {
    bindings: {
      delivery: '<',
      history: '<',
      selectedAction: '<?',
      onSelectAction: '&'
    },
    template: require('./delivery-history-table.html').default,
    controller: DeliveryHistoryTableCtrl
  });
